const backgroundImageUrls = [
	'/images/olos_background_01.jpg',
	'/images/olos_background_02.jpg',
	'/images/olos_background_03.jpg',
	'/images/olos_background_04.jpg',
	'/images/olos_background_05.jpg'
];

module.exports = {
	getImageUrl: function() {
		return backgroundImageUrls[Math.floor(Math.random() * backgroundImageUrls.length)];
	}
};



// WEBPACK FOOTER //
// ./frontend/shared/js/lib/background.js